export default (str: string) => {
  const cleanString = str.replace(/(<([^>]+)>)/gi, '');
  return cleanString.split(' ').length;
};
